import PrepaidCardApi from '@apis/prepaid/PrepaidCardApi';
import userPrepaidCardQueries from '@apis/queries/userPrepaidCardQueries';
import { ErrorResponse } from '@models/error';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

function useRegisterPrepaidGift(id: string) {
    const { t } = useTranslation('prepaidCard');
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () => PrepaidCardApi.registerGiftBox(id),
        onSuccess: async () => {
            toast.success(t('giftDetail.registerSuccess'));
            await queryClient.invalidateQueries({ queryKey: userPrepaidCardQueries._def });
        },
        onError: (e: AxiosError<ErrorResponse>) => {
            toast.error(e.response?.data.message || t('giftDetail.registerError'));
        },
    });
}

export default useRegisterPrepaidGift;
